import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "./slices/authSlice";
import projectsReducer from "./slices/projectsSlice";
import boardsReducer from "./slices/boardsSlice";
import tasksReducer from "./slices/tasksSlice";
import usersReducer from "./slices/usersSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  projects: projectsReducer,
  boards: boardsReducer,
  tasks: tasksReducer,
  users: usersReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "projects", "boards", "tasks", "users"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  // default middleware already includes thunk + serializable checks
});

export const persistor = persistStore(store);
